import { z } from "zod";

export const contactSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, "Name must be at least 2 characters")
    .max(80, "Name must be at most 80 characters"),
  email: z
    .string()
    .trim()
    .email("Please enter a valid email")
    .max(120, "Email must be at most 120 characters"),
  company: z
    .string()
    .trim()
    .max(120, "Company must be at most 120 characters"),
  message: z
    .string()
    .trim()
    .min(10, "Message must be at least 10 characters")
    .max(2000, "Message must be at most 2000 characters"),
  website: z.string(),
});

export type ContactPayload = z.infer<typeof contactSchema>;
